import { render, staticRenderFns } from "./face-roi.vue?vue&type=template&id=012d5f8e&scoped=true&"
import script from "./face-roi.vue?vue&type=script&lang=ts&"
export * from "./face-roi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d5f8e",
  null
  
)

export default component.exports